import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';

export const StaffAssetFirComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
    { id: 'fe_name', field: 'fe_name', headerName: 'FE Name', width: 150 },
    { id: 'ca_name', field: 'ca_name', headerName: 'CA Name', width: 150 },
    { id: 'designation', field: 'designation', headerName: 'Designation', width: 130 },
    { id: 'phone', field: 'phone', headerName: 'Phone Number', width: 150 },
    { id: 'email', field: 'email', headerName: 'Email', width: 200 },
    { id: 'firNo', field: 'firNo', headerName: 'FIR Number', width: 150 },
    { id: 'firDate', field: 'firDate', headerName: 'FIR Date', width: 130 },
    { id: 'policeStation', field: 'policeStation', headerName: 'Police Station', width: 200 },
    { id: 'propertySeizedDate', field: 'propertySeizedDate', headerName: 'Property Seized Date', width: 160 },
  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/asset-mgmt/asset-fir/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          fe_name: item.fe ? item.fe.name_of_fe || '-' : '-',
          ca_name: item.fe ? item.fe.name_of_ca || '-' : '-',
          designation: item.fe ? item.fe.designation || '-' : '-',
          phone: item.fe ? item.fe.ph_number || '-' : '-',
          email: item.fe ? item.fe.email || '-' : '-',
          firNo: item.fir_no || '-',
          firDate: item.fir_date
            ? new Date(item.fir_date).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
          policeStation: item.police_station || '-',
          propertySeizedDate: item.property_seized_date
            ? new Date(item.property_seized_date).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
        }));

        setRows(apiData);
        setSnackbarMessage('Asset FIR data loaded successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch Asset FIR data:', error);
        setSnackbarMessage('Failed to load Asset FIR data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          Asset FIR Master
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
